/**
 * Testimonials Block JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
    // Initialize testimonials carousels
    const testimonialBlocks = document.querySelectorAll('.testimonials-block--layout-carousel');
    
    testimonialBlocks.forEach(block => {
        const carousel = block.querySelector('.testimonials-carousel');
        
        if (!carousel) return;
        
        // Get options from data attributes
        const autoplay = block.dataset.autoplay === 'true';
        const autoplaySpeed = parseInt(block.dataset.autoplaySpeed) || 5000;
        const showArrows = block.dataset.arrows === 'true';
        const showDots = block.dataset.dots === 'true';
        
        // Initialize carousel (using a simple implementation or library like Swiper)
        initTestimonialsCarousel(carousel, {
            autoplay: autoplay,
            autoplaySpeed: autoplaySpeed,
            arrows: showArrows,
            dots: showDots
        });
    });
    
    // Initialize masonry layout if needed
    const masonryBlocks = document.querySelectorAll('.testimonials-block--layout-masonry');
    
    masonryBlocks.forEach(block => {
        // Initialize masonry layout
        initMasonryLayout(block);
    });
});

// Simple carousel implementation
function initTestimonialsCarousel(carousel, options) {
    const items = carousel.querySelectorAll('.testimonial-item');
    const itemCount = items.length;
    
    if (itemCount <= 1) return;
    
    let currentIndex = 0;
    let autoplayInterval;
    
    // Create navigation if needed
    if (options.arrows) {
        createNavigationArrows(carousel);
    }
    
    if (options.dots) {
        createNavigationDots(carousel, itemCount);
    }
    
    // Set up carousel container
    carousel.style.position = 'relative';
    carousel.style.overflow = 'hidden';
    
    const carouselInner = document.createElement('div');
    carouselInner.className = 'testimonials-carousel-inner';
    carouselInner.style.display = 'flex';
    carouselInner.style.transition = 'transform 0.3s ease';
    carouselInner.style.width = `${itemCount * 100}%`;
    
    // Move items to inner container
    items.forEach(item => {
        item.style.width = `${100 / itemCount}%`;
        item.style.flexShrink = '0';
        carouselInner.appendChild(item);
    });
    
    carousel.appendChild(carouselInner);
    
    // Navigation functions
    function goToSlide(index) {
        currentIndex = index;
        const translateX = -(currentIndex * (100 / itemCount));
        carouselInner.style.transform = `translateX(${translateX}%)`;
        
        // Update active dot
        updateActiveDot();
    }
    
    function nextSlide() {
        currentIndex = (currentIndex + 1) % itemCount;
        goToSlide(currentIndex);
    }
    
    function prevSlide() {
        currentIndex = (currentIndex - 1 + itemCount) % itemCount;
        goToSlide(currentIndex);
    }
    
    function updateActiveDot() {
        const dots = carousel.querySelectorAll('.testimonials-dot');
        dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === currentIndex);
        });
    }
    
    // Set up autoplay
    if (options.autoplay) {
        function startAutoplay() {
            autoplayInterval = setInterval(nextSlide, options.autoplaySpeed);
        }
        
        function stopAutoplay() {
            clearInterval(autoplayInterval);
        }
        
        startAutoplay();
        
        // Pause on hover
        carousel.addEventListener('mouseenter', stopAutoplay);
        carousel.addEventListener('mouseleave', startAutoplay);
        
        // Pause when page is not visible
        document.addEventListener('visibilitychange', function() {
            if (document.hidden) {
                stopAutoplay();
            } else if (options.autoplay) {
                startAutoplay();
            }
        });
    }
    
    // Set up arrow navigation
    const prevArrow = carousel.querySelector('.testimonials-prev');
    const nextArrow = carousel.querySelector('.testimonials-next');
    
    if (prevArrow) prevArrow.addEventListener('click', prevSlide);
    if (nextArrow) nextArrow.addEventListener('click', nextSlide);
    
    // Set up dot navigation
    const dots = carousel.querySelectorAll('.testimonials-dot');
    dots.forEach((dot, index) => {
        dot.addEventListener('click', () => goToSlide(index));
    });
    
    // Keyboard navigation
    carousel.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            prevSlide();
        } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            nextSlide();
        }
    });
    
    // Make carousel focusable for keyboard navigation
    carousel.setAttribute('tabindex', '0');
}

function createNavigationArrows(carousel) {
    const prevArrow = document.createElement('button');
    prevArrow.className = 'testimonials-nav testimonials-prev';
    prevArrow.innerHTML = '←';
    prevArrow.setAttribute('aria-label', 'Previous testimonial');
    
    const nextArrow = document.createElement('button');
    nextArrow.className = 'testimonials-nav testimonials-next';
    nextArrow.innerHTML = '→';
    nextArrow.setAttribute('aria-label', 'Next testimonial');
    
    carousel.appendChild(prevArrow);
    carousel.appendChild(nextArrow);
}

function createNavigationDots(carousel, itemCount) {
    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'testimonials-dots';
    
    for (let i = 0; i < itemCount; i++) {
        const dot = document.createElement('button');
        dot.className = 'testimonials-dot';
        dot.setAttribute('aria-label', `Go to testimonial ${i + 1}`);
        if (i === 0) dot.classList.add('active');
        dotsContainer.appendChild(dot);
    }
    
    carousel.appendChild(dotsContainer);
}

function initMasonryLayout(block) {
    // Simple masonry-like layout adjustment
    const grid = block.querySelector('.testimonials-grid');
    
    if (!grid) return;
    
    function adjustMasonry() {
        const items = grid.querySelectorAll('.testimonial-item');
        const columnCount = parseInt(getComputedStyle(grid).columnCount);
        
        if (columnCount === 1) return;
        
        // Reset any previous adjustments
        items.forEach(item => {
            item.style.marginTop = '';
        });
        
        // Adjust spacing for masonry effect
        Array.from(items).slice(columnCount).forEach((item, index) => {
            const topItem = items[index];
            const topItemRect = topItem.getBoundingClientRect();
            const currentItemRect = item.getBoundingClientRect();
            
            const gap = currentItemRect.top - (topItemRect.top + topItemRect.height);
            
            if (gap > 32) { // 2rem gap
                item.style.marginTop = `-${gap - 32}px`;
            }
        });
    }
    
    // Adjust on load and resize
    window.addEventListener('load', adjustMasonry);
    window.addEventListener('resize', debounce(adjustMasonry, 250));
}

// Utility function for debouncing
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}